import {TimelineMax, TweenLite, Sine} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');


function DuoText(selector, refDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        TweenLite.set(selector + ' .text-block--one .text-block__wrapper', {opacity: 0, xPercent: -10, scale: 1, transformOrigin: '90% 0'});
        TweenLite.set(selector + ' .text-block--two .text-block__wrapper', {opacity: 0, xPercent: 10, scale: 1, transformOrigin: '10% 0'});
        TweenLite.set(selector, {opacity: 1});

        const obj = {progress: 0, on: false, section: document.querySelector(selector)};
        const tl = new TimelineMax({
            paused: true,
            onUpdate: () => {
                if (obj.progress < 0.25) {
                    if (!obj.on) return;
                    obj.on = false;
                    obj.section.classList.remove('active');
                    TweenLite.set([selector, selector + ' .text-block'], {zIndex: 1, pointerEvents: 'none'});
                    TweenLite.to(selector + ' .text-block--one .text-block__wrapper', 0.4, {opacity: 0, xPercent: -10, scale: 1, ease: Sine.easeInOut});
                    TweenLite.to(selector + ' .text-block--two .text-block__wrapper', 0.4, {opacity: 0, xPercent: 10, scale: 1, ease: Sine.easeInOut});
                    return;
                }
                if (obj.progress > 0.75) {
                    if (!obj.on) return;
                    obj.on = false;
                    obj.section.classList.remove('active');
                    TweenLite.set([selector, selector + ' .text-block'], {zIndex: 1, pointerEvents: 'none'});
                    TweenLite.to(selector + ' .text-block .text-block__wrapper', 0.4, {opacity: 0, xPercent: 0, scale: 0.9, ease: Sine.easeInOut});
                    return;
                }
                if (obj.on) return;
                obj.section.classList.add('active');
                TweenLite.set([selector, selector + ' .text-block'], {zIndex: 100, pointerEvents: 'all'});
                TweenLite.to(selector + ' .text-block .text-block__wrapper', 0.6, {opacity: 1, xPercent: 0, scale: 1, ease: Sine.easeInOut});
                obj.on = true;
            }
        });

        tl.set(obj, {progress: 0}, 'st');
        tl.to(obj, refDuration * 0.3, {progress: 0.5}, 'st');
        tl.to(obj, refDuration * 0.3, {progress: 1}, 'st+=' + refDuration * 0.55);


        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        Shortcuts.destroyTimeline(constructor);
        _created = false;
    };

    constructor.startDuration = refDuration * 0.15;
    constructor.totalDuration = refDuration;

    return constructor;
}

module.exports = DuoText;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/texts/DuoText.js